import React from "react";

const LoginInputTitle = ({ title, required = false }) => {
  return (
    <div className="text-[1em] font-bold pl-2">
      {title} {required && <span className="text-red-600">*</span>}
    </div>
  );
};

export default LoginInputTitle;
